module.exports = __webpack_public_path__ + "static2023-4-17/img/active_coin.bf38bcbd.png";